import React, {
    FC,
    useRef,
} from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    IconButton,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {IReview} from "../../../interfaces/Interfaces";
import {TextInfoItem} from "../../table/TextInfoItem";
import {IdlocaGeneric} from "../../../locales/IdlocaGeneric";
import {RenderRating} from "../list/RenderRating";
import {ReviewAuthorInfo} from "./ReviewAuthorInfo";

interface IGarageReviews {
    reviews: IReview[];
}

export const GarageReviews: FC<IGarageReviews> = ({reviews}) => {

    const visibleReviews = reviews.slice(0, 20);
    const sliderRef = useRef<HTMLDivElement>(null);

    const scrollLeft = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({left: -300, behavior: "smooth"});
        }
    };

    const scrollRight = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({left: 300, behavior: "smooth"});
        }
    };

    return (
        <Box sx={{position: "relative", width: "100%", mt: 2}}>
            <IconButton
                onClick={scrollLeft}
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "0px",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                }}
            >
                <ArrowBackIosIcon/>
            </IconButton>
            <Box
                ref={sliderRef}
                sx={{
                    overflowX: "auto",
                    display: "flex",
                    scrollBehavior: "smooth",
                    "&::-webkit-scrollbar": {display: "none"},
                    gap: 2,
                    padding: 3,
                    marginLeft: "42px",
                    marginRight: "42px",
                }}
            >
                {visibleReviews.map((review, idx) => (
                    <Card key={idx} sx={{minWidth: 250, flex: "0 0 auto"}}>
                        <CardContent>
                            <ReviewAuthorInfo review={review}/>
                            <TextInfoItem
                                locaId={IdlocaGeneric.rating}
                                value={review?.rating}
                                renderer={<RenderRating value={review?.rating?.toString(10)}/>}
                            />
                            <Typography
                                variant="body2"
                                gutterBottom
                                sx={{
                                    maxWidth: 200,
                                    maxHeight: 200,
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    WebkitLineClamp: 10,
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {review?.text?.text}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}
            </Box>
            <IconButton
                onClick={scrollRight}
                sx={{
                    position: "absolute",
                    top: "50%",
                    right: "0px",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                }}
            >
                <ArrowForwardIosIcon/>
            </IconButton>
        </Box>
    );
};


